import { AnthropicInstallation } from 'onboarding/llm-analytics/anthropic.tsx';
import { OnboardingContentWrapper } from 'components/Docs/OnboardingContentWrapper';
import NotableGenerationProperties from "../../../../contents/docs/llm-analytics/_snippets/notable-generation-properties.mdx";
import * as React from 'react';
export default {
  AnthropicInstallation,
  OnboardingContentWrapper,
  NotableGenerationProperties,
  React
};